'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28(evaluator$24) {
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$28__f_evaluator$4 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$28__f_evaluator$4 = evaluator$24;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$28() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$28 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$28 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$28.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestsAcceptedListItem$$anon$28__f_evaluator$4.apply__O();
  return ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Ljkugiya_ulid_ULID) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$28 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$28, "app.api.DrugRequestsAcceptedListItem$$anon$28", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$28: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$28 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$28 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$28.js.map
